<div class="ipad-width">
  <div mat-dialog-title class="title">
    @if (this.order.expiring) {
      <label class="expiring-order-badge">{{'order_details.order_expiry_time' | translate: {numdays: this.order.expiryDays} }}</label>
    }

    @if (this.order.expired) {
      <label class="expired-order-badge">{{'orders_list.expired' | translate}}</label>
    }

    @if (this.order.isPending) {
      <label class="pending-order-badge">{{'orders_list.pending' | translate}}</label>
    }
    @if (this.order.perpetual) {
      <label class="perpetual-order-badge">{{'orders_list.perpetual' | translate}}</label>
    }
    <div class="close-button">
      <button mat-icon-button id="confirm-close" attr.aria-label="{{ 'app.close_button' | translate }}" (click)="onClose()"><mat-icon>close</mat-icon>
    </button>
  </div>

  @if (showFormError) {
    <form-error-alert class="form-alert" [errorMessage]="errMsg" [externalStyles]="errMsgStyle"></form-error-alert>
  }
  <img class="files-icon" src="../assets/images/files.svg" />
</div>
<div mat-dialog-content class="mat-typography">
  <div class="subscriptionNumberlabel">
    <label>{{ 'order_details.subscription_number' | translate }}:&nbsp;{{order.subscriptionNumber}}</label>
  </div>
  @if (showDetails==false) {
    <div>
      <label
        id="seeLink"
        class="details-link clickable-pointer"
        (click)="handleShowDetailsEvent()"
        tabindex="0"
        (keydown.enter)="$event.preventDefault(); handleShowDetailsEvent()">
        {{ 'order_details.see_additional_details' | translate }}
        <img src="../assets/images/arrow-down.png" class="Arrow-Dropdown clickable-pointer">
      </label>
    </div>
  }

  @if (showDetails==true) {
    <div>
      <div>
        <label
          id="closeLink"
          class="details-link clickable-pointer"
          (click)="handleShowDetailsEvent()"
          tabindex="0"
          (keydown.enter)="$event.preventDefault(); handleShowDetailsEvent()">
          {{ 'order_details.hide_additional_details' | translate }}
          <img src="../assets/images/arrow-up.png" class="Arrow-Dropdown clickable-pointer">
        </label>
      </div>
      @if (order.invoiceOwnerAccountName) {
        <div class="detail-whole-line" [matTooltip]="invoiceOwnerAccountNameTooltip">
          <label class="order-detail-label">{{ 'order_details.invoiceOwnerAccountName' | translate }}:&nbsp;</label>
          <label id="invoiceOwnerAccountName" class="poNumberlabel">{{order.invoiceOwnerAccountName}}</label>
        </div>
      }
      <div class="detail-whole-line" [matTooltip]="resellerPOTooltip">
        <label class="order-detail-label">{{ 'order_details.po_number' | translate }}:&nbsp;</label>
        <label id="resellerPONumber" class="poNumberlabel">{{order.poNumber}}</label>
      </div>
      <div class="detail-whole-line" [matTooltip]="resellerSapIdTooltip">
        <label class="order-detail-label">{{ 'order_details.reseller_SAP_Id' | translate }}:&nbsp;</label>
        <label id="resellerSapId" class="poNumberlabel">{{order.resellerSapId}}</label>
      </div>
      <div class="detail-whole-line" [matTooltip]="trackingNumberTooltip">
        <label class="order-detail-label">{{ 'order_details.tracking_number' | translate }}:&nbsp;</label>
        <label id="trackingNumber" class="poNumberlabel">{{order.orderNumber}}</label>
      </div>
      <div class="detail-whole-line" [matTooltip]="customerPOTooltip">
        <label class="order-detail-label" >{{ 'order_details.customerPONumber' | translate }}:&nbsp;</label>
        <label id="customerPONumber" class="poNumberlabel" >{{order.customerPoNumber}}</label>
      </div>
      <div class="detail-whole-line" [matTooltip]="customerSapIdTooltip">
        <label class="order-detail-label">{{ 'order_details.customerSapId' | translate }}:&nbsp;</label>
        <label id="customerSapId" class="poNumberlabel">{{order.customerSapId}}</label>
      </div>
      <div class="detail-whole-line" [matTooltip]="sapOrderIdTooltip">
        <label class="order-detail-label">{{ 'order_details.sapOrderId' | translate }}:&nbsp;</label>
        <label id="sapOrderId" class="poNumberlabel">{{order.sapOrderId}}</label>
      </div>
      <div class="rectangle-copy-title"></div>
    </div>
  }

  <div class="order-details-label">
    <label>{{ 'order_details.start_date' | translate }}:&nbsp;{{order.orderDate| date:'yyyy-MM-dd'}}</label>
    <label class="float-right poNumberlabel">{{ 'order_details.term' | translate }}:&nbsp;{{order.term}}</label>
  </div>
  <div class="whole-line" [matTooltip]="nameTooltip">
    <label class="order-detail-label">{{ 'order_details.order_assigned_to' | translate }}:&nbsp;</label>
    @if (order.unassigned) {
      <label class="accountLabel">{{ ('orders_list.unassigned' | translate).toLowerCase()}}</label>
    }
    @if (order.unassigned==false) {
      <label
        id="accountNameLabel"
        class="accountLabel"
        >
        {{order.accountName}}
      </label>
    }
  </div>
  <div class="rectangle-copy-title"></div>
  <app-order-licenses [orderDetails]="order"></app-order-licenses>
</div>

@if (this.order.unassigned && !this.order.expired) {
  <div mat-dialog-actions>
    <app-select-account
      [accountFormGroup]="assignSection"
      [excludeAccount]="this.order.accountId"
      (selectedAccountChanged)="this.handleSelectedAccount($event)">
    </app-select-account>
  </div>
}

<div mat-dialog-actions align="end">
  @if (this.order.unassigned && !this.order.expired) {
    <button
      mat-stroked-button
      app-rbac category="accounts" [actions]="['add']" [mode]="restrictedAccess ? 'readonly' : null"
      class="btn snap-left"
      [disabled]="restrictedAccess"
      attr.aria-label="{{ 'order_details.create_new_account' | translate }}"
      (click)="onCreateNewAccount($event)">
      {{ 'order_details.create_new_account' | translate }}
    </button>
  }
  <button mat-stroked-button class="btn" mat-dialog-close attr.aria-label="{{ 'app.close' | translate }}" (click)="onClose()">
    {{ 'app.close_button' | translate }}
  </button>
  @if (this.order.unassigned && !this.order.expired) {
    <button
      mat-flat-button
      class="btn"
      [disabled]="disableAssignButton || restrictedAccess"
      color=primary
      attr.aria-label="{{ 'order_details.assign_button' | translate }}"
      (click)="onAssignOrder($event)"
      id="assign-order-button">
      {{ 'order_details.assign_button' | translate }}
    </button>
  }
  @if (this.order.undeployed && !this.order.expired) {
    <button
      mat-flat-button
      class="btn"
      [disabled]="restrictedAccess"
      color=primary
      attr.aria-label="{{ 'order_details.deploy_button' | translate }}"
      (click)="onDeployOrder()"
      id="deploy-order-button">
      {{ 'order_details.deploy_button' | translate }}
    </button>
  }
  @if (this.order.canActivate && !this.order.expired) {
    <button
      mat-flat-button
      class="btn"
      [disabled]="restrictedAccess"
      color=primary
      attr.aria-label="{{ 'order_details.activate_button' | translate }}"
      (click)="onActivateOrder()"
      id="activate-order-button">
      {{ 'order_details.activate_button' | translate }}
    </button>
  }
</div>
</div>